/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


// Include react
import React from "react";
import ReactDOM from "react-dom";

// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

import widgetConfig from '../../common/widgetConfigs'



// Creating the DOM element to pass the react-fusioncharts component
class RenderChart extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    FusionCharts.options.license({
      key: this.props.fusionKey,
      creditLabel: false,
    });
  }
  render() {
    const config = {
      ...this.props.chartConfigs,
      dataSource: {
        ...this.props.chartConfigs && this.props.chartConfigs.dataSource,
        chart: {
          rotateLabels: "0",
          labelDisplay: "wrap",
          baseFont: "OpenSans",
          baseFontSize: "16",
          baseFontColor: "#000d1c",
          yAxisNameFont: "OpenSans",
          yAxisNameFontSize: "16",
          yAxisNameFontColor: "#000d1c",
          yAxisNameFontBold: "0",
          yAxisNameFontItalic: "0",
          xAxisNameFont: "OpenSans",
          xAxisNameFontSize: "16",
          xAxisNameFontColor: "#000d1c",
          xAxisNameFontBold: "0",
          xAxisNameFontItalic: "0",
          plotBorderThickness: 2,
          color: '#dfe1a5',
          hoverColor: '#94981b',
          plotBorderColor: '#94981b',

          ...this.props.chartConfigs && this.props.chartConfigs.dataSource && this.props.chartConfigs.dataSource.chart,
        }
      }
    };
    return (<ReactFC {...config} />);
  }
}

export default RenderChart;
